import { render, staticRenderFns } from "./Privacity.vue?vue&type=template&id=13c5c473&scoped=true"
import script from "./Privacity.vue?vue&type=script&lang=js"
export * from "./Privacity.vue?vue&type=script&lang=js"
import style0 from "./Privacity.vue?vue&type=style&index=0&id=13c5c473&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c5c473",
  null
  
)

export default component.exports